import axiosInstance from "./axiosInstance";

const obtenerTemporadas = async () => {
  return await axiosInstance.get(`${process.env.REACT_APP_BASE_URL}/obtenerTemporadas`);
};

export default obtenerTemporadas;
